import { type AxiosResponse } from 'axios';

import { get, put } from '@utilities';

export const fetchUserDetails = async (): Promise<AxiosResponse> => await get('user');
export type FreeformControlPreset = 'SKETCHUP' | 'LEGACY';
export const fetchFreeformControlPreset = async (): Promise<AxiosResponse<{ controlPreset: FreeformControlPreset | null }>> =>
	await get('user/editor-preferences/freeform-controls');
export const saveFreeformControlPreset = async (controlPreset: FreeformControlPreset): Promise<AxiosResponse<{ controlPreset: FreeformControlPreset }>> =>
	await put('user/editor-preferences/freeform-controls', { controlPreset });
export const updateUserDetails = async (data: Record<string, any>): Promise<AxiosResponse> => await put('user', data);
export const updateProfilePicture = async (data): Promise<AxiosResponse> => await put('user/profile_picture', data);
export const autocompleteUser = async (prefix: any): Promise<AxiosResponse> =>
	await get(`user/autocomplete?prefix=${prefix}&user_type=INTERNAL`);
export const fetchUserPermissions = async (userId): Promise<AxiosResponse> => await get(`user/${userId}/permissions`);
export const updateUserPermissions = async (data, userId): Promise<AxiosResponse> =>
	await put(`user/${userId}/permissions`, data);
export const fetchCredits = async (userId): Promise<AxiosResponse> => await get(`credits/${userId}`);
export const updateCredits = async (userId, credits): Promise<AxiosResponse> =>
	await put(`credits/${userId}/limit?credits=${encodeURIComponent(credits)}`);
